// extracted by mini-css-extract-plugin
module.exports = {"base":"GoogleAuthButton_base__2zzA8","icon":"GoogleAuthButton_icon__2TKiI"};